import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SeoContext = createContext({ global: null, byPage: {}, ready: false });

const DEFAULT_GLOBAL = {
  site_name: "Herbalife Shop",
  title_template: "%s | Herbalife Shop",
  default_title: "Herbalife Shop — Nutrition, énergie, bien-être",
  default_description: "Distributeur Herbalife indépendant : nutrition essentielle, énergie vibrante et bien-être au quotidien.",
  default_image: "",
  default_keywords: "herbalife, nutrition, shake, formula 1, bien-être, distributeur",
  locale: "fr_FR",
  twitter_handle: "",
  organization_url: "",
  robots_default: "index,follow",
};

export function SeoProvider({ children }) {
  const [global, setGlobal] = useState(DEFAULT_GLOBAL);
  const [byPage, setByPage] = useState({});
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [g, slugs] = await Promise.all([
          api.get("/site/seo-global"),
          api.get("/site/seo-pages"),
        ]);
        if (cancelled) return;
        setGlobal({ ...DEFAULT_GLOBAL, ...g.data });
        // Eagerly fetch page-level overrides in parallel
        const entries = await Promise.all(
          (slugs.data || []).map(async (p) => {
            try {
              const r = await api.get(`/site/seo-page/${p.slug}`);
              return [p.slug, r.data || {}];
            } catch {
              return [p.slug, {}];
            }
          })
        );
        if (cancelled) return;
        setByPage(Object.fromEntries(entries));
      } catch {
        // keep defaults
      } finally {
        if (!cancelled) setReady(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <SeoContext.Provider value={{ global, byPage, ready }}>
      {children}
    </SeoContext.Provider>
  );
}

export function useSeoContext() {
  return useContext(SeoContext);
}
